module.exports = __webpack_public_path__ + "media/src/images/etsy-1657c9f45f45c01df8c5ee8fb8e34921.png";